import { faMobileAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "gatsby";
import React from "react";
import logo from "../img/steute-logo.svg";

const Navbar = class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      navBarActiveClass: "",
    };
  }

  // gtagConversion = () => {
  //   typeof window !== "undefined" &&
  //     window.gtag("event", "conversion", {
  //       send_to: "AW-1068261550/ZPZ0CJPzjMUCEK7Bsf0D",
  //       value: 1.0,
  //       currency: "PLN",
  //     });
  // };

  toggleHamburger = () => {
    // toggle the active boolean in the state
    this.setState(
      {
        active: !this.state.active,
      },
      // after state has been updated,
      () => {
        // set the class in state for the navbar accordingly
        this.state.active
          ? this.setState({
              navBarActiveClass: "is-active",
            })
          : this.setState({
              navBarActiveClass: "",
            });
      }
    );
  };

  render() {
    return (
      <nav
        className="navbar is-fixed-top is-transparent shadow-line"
        role="navigation"
        aria-label="main-navigation"
      >
        <div className="container">
          <div className="navbar-brand">
            <Link
              to="/"
              className="navbar-item has-no-hover is-no-active has-no-focus"
              title="Logo"
            >
              <div className="is-flex-centered">
                <img src={logo} alt="steute" style={{ width: "auto" }} />
                {/* <div className="is-size-5 has-text-centered page-logo">wylaczniki-<span className="">nozne.pl</span></div> */}
              </div>
            </Link>
            {/* Hamburger menu */}
            <div
              className={`navbar-burger burger ${this.state.navBarActiveClass}`}
              data-target="navMenu"
              onClick={() => this.toggleHamburger()}
            >
              <span />
              <span />
              <span />
            </div>
          </div>
          <div
            id="navMenu"
            className={`navbar-menu ${this.state.navBarActiveClass}`}
          >
            <div className="navbar-start has-text-centered"></div>
            <div className="navbar-end has-text-centered">
              <Link
                className="navbar-item"
                activeClassName="navbar-item-active"
                to="/"
              >
                STRONA GŁÓWNA
              </Link>

              <Link
                className="navbar-item"
                activeClassName="navbar-item-active"
                to="/produkty"
              >
                PRODUKTY
              </Link>
              <Link
                className="navbar-item"
                activeClassName="navbar-item-active"
                to="/baza-wiedzy"
              >
                BAZA WIEDZY
              </Link>
              <Link
                className="navbar-item"
                activeClassName="navbar-item-active"
                to="/poznaj-steute"
              >
                POZNAJ STEUTE
              </Link>
              <Link
                className="navbar-item"
                activeClassName="navbar-item-active"
                to="/kontakt"
              >
                KONTAKT
              </Link>
              <Link
                className="navbar-item is-no-active has-no-focus is-flex-centered"
                to="/kontakt"
              >
                <div className="navbar-phone">
                  <a className="is-phone-link" href="tel:+48228430820">
                    <div className="has-text-weight-semibold is-size-5">
                      + 48 22 843 08 20
                    </div>
                    <div>
                      <FontAwesomeIcon
                        className="navbar-phone-icon"
                        icon={faMobileAlt}
                      />
                      <span>zadzwoń do nas</span>
                    </div>
                  </a>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </nav>
    );
  }
};

export default Navbar;
